module.exports = __webpack_public_path__ + "static/media/Icon_menu_bestshop.6eb47f57.svg";